import { inject, observer } from 'mobx-react';
import React from 'react'
import ModalWrapper from './ModalWrapper';
import { ReactComponent as CloseIcon } from "../../svg/close.svg";
import SubscriptionPlan from './SubscriptionPlan';


@inject('store') @observer
class PricingModal extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      selectedPeriod: null,
      loaded: false
    }
  }

  async componentDidMount(){
    if(!this.props.store.subscriptionPlans.year.length){
      await this.props.store.fetchPricingData()
      this.setState({
        loaded: true
      })
    }
    this.setState({
      selectedPeriod: 'year',
      loaded: true
    })
  }

  setPeriod(){
    let selectedPeriod = 'year'
    if(this.state.selectedPeriod === 'year'){
      selectedPeriod = 'month'
    }
    this.setState({
      selectedPeriod
    })
  }

  close(){
    this.props.store.toggleSubscriptionModal(false)
  }

  initCheckout(ppId, isTeam = false){
    if(isTeam){
      window.location.href = `https://mediamodifier.com/dashboard/team`
    }else{
      window.location.href = 'https://mediamodifier.com/pricing'
    }
  }

  fridayPage(){
    window.location.href = 'https://mediamodifier.com/valentine-offer'
  }

  getPlans(plans){
    const activePlan = plans[this.state.selectedPeriod][0]
    //title, cost, subtitle, features, planClass, buttonClass, action, buttonText
    const freePlan = {
      title: 'Starter',
      amount: 'Free',
      subtitle: 'Valid forever, never billed!',
      features: [
        'Watermarked images',
        'Limited download resolutions',
        'No publish tools',
        'No custom content'
      ],
      planClass: 'free-plan',
      buttonClass: 'btn btn-bordered w-100 free-plan-btn',
      action: this.close.bind(this),
      buttonText: 'Continue With Less'
    }
    const teamPlanAmount = this.state.selectedPeriod === 'year' ? 37.5 : 45
    const period = this.state.selectedPeriod
    const formattedTeamPlanAmount = `$${period === 'month' ? Number(teamPlanAmount).toFixed(0) : Number(teamPlanAmount).toFixed(2)}/<span class='p-month'>month</span>`
    const teamPlan = {
      title: 'Team',
      amount: formattedTeamPlanAmount,
      subtitle: 'Best for teams & agencies',
      features: [
        'Everything in professional plus',
        'Up to 5 team members',
        'Assigned team admin',
        'Central billing',
        'Shared team assets & designs',
        '90 USD / year for every additional member'
      ],
      planClass: 'team-plan',
      buttonClass: 'btn btn-bordered w-100 pink-btn',
      action: () => this.initCheckout(null, true),
      buttonText: 'Subscribe now'
    }
    const amount = `$${period === 'month' ? Number(activePlan.amount).toFixed(2) : Number(activePlan.amount / 12).toFixed(2)}/<span class='p-month'>month</span>`
    const paid = {
      ...activePlan,
      highlighted: true,
      highlightedText: 'Summer sale -50%',
      linedAmount: `$15.83/<span class='p-month'>month</span>`,
      amount: `$${period === 'month' ? Number(19).toFixed(2) : Number(8.25).toFixed(2)}/<span class='p-month'>month</span>`,
      title: 'Professional',
      action: () => this.initCheckout(activePlan.pp_id),
      buttonText: 'Subscribe now',
      planClass: 'pro-plan',
      buttonClass: 'btn btn-danger w-100 pink-btn',
      subtitle: 'Best for individuals',
      //subtitle: `Billed ${activePlan.name}ly`,
    }
    const fridayPlan = {
      title: 'VALENTINES SALE',
      amount: `$99/<span class='p-month'>year</span>`,
      subtitle: 'Billed yearly',
      features: [
        'Everything in PRO',
        'Recurring discount',
        '+Best Price',
      ],
      planClass: 'valentines-plan',
      buttonClass: 'btn btn-bordered w-100 valentines-plan-btn',
      action: this.fridayPage.bind(this),
      buttonText: 'Get Offer Now'
    }
    return (
      <>
        <SubscriptionPlan {...freePlan} />
        <SubscriptionPlan activePeriod={period} {...paid} />
        <SubscriptionPlan {...teamPlan} />
      </>
    )
  }

  render(){
    const { subscriptionPlans, modals: { subscriptionModalOpen } } = this.props.store
    const { selectedPeriod, loaded } = this.state
    if(!subscriptionModalOpen || !loaded){
      return <div />
    }
    return (
      <ModalWrapper
        modalClass={'subscription-modal'}
        close={this.close.bind(this)}
      >
        <div className='subscription-modal__wrapper'>
          <h2 className='subscription-modal__heading'>Choose a plan that is right for you</h2>
          <p className='subscription-modal__subheading' style={{ marginBottom: '0rem' }}>
            Find a plan that works for you. <strong>Save 20% with annual payment.</strong>
          </p>
          <p className='subscription-modal__subheading' style={{ fontWeight: 700, color: '#f73767' }}>
            Our Hot Summer Sale has started! Choose yearly billing to get 50% off!
          </p>
          <div className='subscription-modal__period'>
            <span className='subscription-modal__period__left'>Monthy</span>
            <div className='custom-control custom-switch'>
              <input 
                type='checkbox'
                className='custom-control-input'
                id="customSwitch1"
                onChange={() => this.setPeriod()}
                checked={selectedPeriod === 'year'}
              />
              <label className="custom-control-label" htmlFor="customSwitch1" />
            </div>
            <span className='subscription-modal__period__right'>Yearly</span>
          </div>
          <div className='subscription-modal__plans'>
            {this.getPlans(subscriptionPlans)}
          </div>
          <div className='subscription-modal__footer'>
            <span className='gray subscription-modal__disclaimer'>
              Money back guarantee! Applicable taxes not included. All prices in USD.
            </span>
          </div>
        </div>
        <CloseIcon className='close-icon cursor-pointer' onClick={this.close.bind(this)} />
      </ModalWrapper>
    )
  }

}

export default PricingModal